import { Alert, Text } from '@reveni-io/reveni-ui'

const BlockingMessage = ({ actionForTransactionTypes, message }) => {
  if (!actionForTransactionTypes?.length) return null

  return (
    <Alert type="info">
      <Text type="bodyMRegular">{message}</Text>
    </Alert>
  )
}

export default BlockingMessage
